import React, { useState } from "react";
import EulaIcon from "../../assets/images/eula.png";
import NavTagline from "../../components/nav-tagline/nav-tagline";
import HiTrustLogo from "../../assets/images/HITRUSTCSFCertifiedLogo_white.png";
import PoweredByAWS from "../../assets/images/poweredby-aws.png";
import EulaAction from "./EULAAction";

const EulaDefault = () => {
  const currentYear = new Date().getFullYear();
  const [processing, SetProcesing] = useState(false);
  return (
    <div className="Eula">
      <NavTagline />
      <section className="layout-container">
        <div className="container">
          <img src={EulaIcon} className="w-md2" alt="Verified User Icon" />
          <div className="text-size5"> End User License Agreement </div>
          <p className="">
            <b>
              To use the site you must accept this license agreement by checking
              the box at the bottom of the page and clicking "Accept" button.
            </b>
          </p>
          <p>
            <b>NOTICE TO USER:</b> THIS IS A CONTRACT, BINDING AGREEMENT BETWEEN
            YOU AND SECURE EXCHANGE SOLUTIONS, INC. ("SES") AS OWNER AND
            LICENSOR OF THE PROGRAMS AND HOSTED SUBSCRIPTION SERVICES SUBJECT TO
            THIS AGREEMENT. READ THIS AGREEMENT CAREFULLY BEFORE INSTALLING AND
            USING THESE PROGRAMS.
          </p>
          <p>
            SES IS WILLING TO LICENSE THE COMPUTER SOFTWARE APPLICATION
            PRODUCTS, PROPRIETARY DATABASES AND RELATED DOCUMENTATION AND USE OF
            THE SERVICES AVAILABLE ON THIS SITE WHICH YOU SUBSCRIBE FOR BY
            ACCEPTING THIS AGREEMENT (THE "PROGRAMS") TO YOU ON THE CONDITION
            THAT YOU ACCEPT ALL OF THE TERMS AND CONDITIONS CONTAINED IN THIS
            END USER LICENSE AGREEMENT (THIS "AGREEMENT"). THE PROGRAMS CONTAIN
            CERTAIN COMPUTER SOFTWARE APPLICATIONS, DOCUMENTATION, OR OTHER
            PROPRIETARY MATERIAL THAT ARE THE PROPERTY OF SES AND ITS SUPPLIERS
            AND ARE REQUIRED TO BE USED IN ORDER FOR YOU TO USE EACH OF THE
            PROGRAMS FOR ITS INTENDED PURPOSE. YOUR USE OF THE PROGRAMS IS
            SUBJECT TO YOUR ACCEPTANCE OF THE TERMS AND CONDITIONS OF THIS
            AGREEMENT. PLEASE READ THE TERMS AND CONDITIONS CAREFULLY BEFORE
            INSTALLING OR USING THE PROGRAMS. BY CLICKING THE "I AGREE" BUTTON
            BELOW, INSTALLING OR USING THE PROGRAMS, YOU ARE ACKNOWLEDGING THAT
            YOU UNDERSTAND THIS AGREEMENT AND AGREE TO BE BOUND BY IT AND ARE
            INDICATING YOUR ACCEPTANCE OF THIS AGREEMENT AND THE LICENSE
            DESCRIBED IN THIS AGREEMENT. IF YOU ARE PROCURING THE PROGRAMS ON
            BEHALF OF AN ENTITY OR ORGANIZATION, YOU REPRESENT AND WARRANT THAT
            YOU ARE AUTHORIZED TO ENTER INTO THIS AGREEMENT ON BEHALF OF SUCH
            ENTITY OR ORGANIZATION AND THAT ALL REPRESENTATIONS MADE BY YOU ON
            BEHALF OF SUCH ENTITY OR ORGANIZATION ARE TRUE AND CORRECT. IF YOU
            DO NOT AGREE TO THE TERMS OF THIS AGREEMENT, SES IS UNWILLING TO
            LICENSE THE PROGRAMS TO YOU AND SHALL HAVE NO OBLIGATION TO PROVIDE
            YOU ACCESS TO USE ANY OF THE PROGRAMS. IN THAT EVENT, YOU MAY NOT
            INSTALL OR USE THE PROGRAMS AND YOU MUST CLICK ON THE ["CANCEL"/"I
            DECLINE"] BUTTON BELOW.{" "}
          </p>
          <p>
            IF YOU ARE USING THE PROGRAMS THROUGH AN ORGANIZATION WHICH IS A
            PARTY TO A HEALTH INFORMATION SERVICE PROVIDER ("HISP") SUBSCRIPTION
            AGREEMENT WITH SES, THIS AGREEMENT MAY NOT BE APPLICABLE TO YOU AND
            YOUR USE OF THE PROGRAMS AND SERVICES AVAILABLE ON THIS SITE IS
            SUBJECT SOLELY TO THE TERMS OF THAT HISP SUBSCRIPTION AGREEMENT AND
            YOU WILL NOT BE BOUND TO THE TERMS OF THIS AGREEMENT. HOWEVER, TO
            USE THE PROGRAMS IN ACCORDANCE WITH THE APPLICABLE HISP SUBSCRIPTION
            AGREEMENT, YOU MUST CLICK "I AGREE" BELOW. IN THE EVENT OF ANY
            CONFLICT BETWEEN THIS AGREEMENT AND THE TERMS OF ANY APPLICABLE HISP
            SUBSCRIPTION AGREEMENT, THE TERMS OF THE APPLICABLE HISP
            SUBSCRIPTION AGREEMENT SHALL CONTROL.
          </p>

          <p>
            BY INSTALLING OR OTHERWISE USING ANY UPDATES TO THE PROGRAMS THAT
            YOU RECEIVE, YOU AGREE TO BE BOUND BY ANY ADDITIONAL TERMS AND
            CONDITIONS, INCLUDING REQUIREMENTS FOR THE PAYMENT OF SUBSCRIPTION
            FEES, LICENSE FEES, OR OTHER AMOUNTS TO SES OR ITS AFFILIATES THAT
            ACCOMPANY SUCH UPDATES. IF YOU DO NOT AGREE TO SUCH ADDITIONAL TERMS
            AND CONDITIONS, DO NOT INSTALL OR USE SUCH UPDATES.
          </p>
          <ol>
            <li>
              <span className="ft-wt">License Grant; Termination.</span> (a) SES
              hereby grants You in accordance with the terms and conditions of
              this Agreement, a limited term, non-exclusive, non-transferable
              right to use each of the Programs for its intended purpose to
              permit you to access and use the Services (the "License"). The
              License is for binary executable code only and is intended to
              allow You to use each of the Programs for its intended purpose to
              permit You to access and use the Services. (b) Unless otherwise
              expressly indicated for certain Programs, this License is
              effective until terminated and shall immediately terminate (i)
              automatically upon failure by You to comply with any of its terms;
              (ii) at the discretion of SES in the event that You timely fail to
              pay any applicable Subscription Fees in full at any time; (iii) in
              the event that any applicable HISP Subscription Agreement is
              terminated or expires in accordance with such applicable HISP
              Subscription Agreement; or (iv) by You as provided in Section 1(d)
              below or Section 5(e) of this Agreement, as applicable. (c) Upon
              any termination of the License provided under this Agreement, You
              shall (i) have no further right to make use of the Programs or
              Services in any manner whatsoever; (ii) immediately cease and
              desist from any use (whether for production or archival purposes)
              of the Programs; and (iii) immediately destroy the original and
              any copies of the Programs in Your possession or otherwise
              installed on any of Your information technology infrastructure. In
              the event of a termination, You agree that any provisions of this
              Agreement that operate to protect SES shall remain in force. (d)
              You may cancel your subscription to SES Online, if applicable, at
              any time by providing notice of such cancellation via email to
              support@secureexsolutions.com. Any cancellation in accordance with
              this Section 1(d) shall become effective at the end of the month
              during which such cancellation is received by SES. (e) Terms,
              conditions, features, pricing, service and support are subject to
              change by SES without notice.
            </li>
            <li>
              <span className="ft-wt">Availability of Programs; Payment.</span>{" "}
              (a) SES shall provide you with access to the Programs to permit
              you to access and use the Services and provide You with the
              Support Services described in Section 6 of this Agreement. (b) You
              agree to download and install the Programs or components thereof,
              if any, as necessary and required for proper access to and use of
              the Programs in accordance with the License. (c) You shall provide
              all things other than the Programs for the Programs to operate and
              for You to receive and make use of the Programs including, without
              limitation, facilities, hardware, software, staff, equipment,
              communications access and operating systems required for the
              operation of the Programs. (d) You acknowledge that the Programs
              through their normal operation provide periodic electronic
              reporting to SES on the use and status of Your operation and use
              of the Programs, including, without limitation, tracking user
              identification information, reporting the internet protocol
              addresses of the computers or accessing or using the Programs for
              the purposes of identifying and authenticating the persons within
              Your organization using the Programs and the identification and
              authentication of You as an organization. (e) You agree to pay SES
              all amounts related to Your use of the Programs and Support
              Services (collectively, "Subscription Fees"), if any, on or before
              the first day of each calendar month by recurring charge via
              credit card authorization, automatic clearinghouse payment
              transaction authorization provided by You to SES or as otherwise
              required by SES for certain Programs, unless your use of the
              Programs is subject to an applicable HISP Subscription Agreement
              under which another party is obligated to pay Subscription Fees on
              your behalf or otherwise in order to permit you to access and use
              the Programs and Services subject to the License, in which case
              you are not responsible for payment of any Subscription Fees.
            </li>
            <li>
              <span className="ft-wt">
                Copy, Use and Transfer Restrictions.
              </span>
              (a) The Programs are copyrighted to SES and are the sole and
              exclusive property of SES. You shall not give, sell, or otherwise
              distribute copies of the Programs or permit access to or use of
              the Programs to or by third parties, except as permitted by the
              License. (b) The License permits You to install and use the
              Programs on a single central processing unit or server for Your
              use only in accordance with the intended purpose of the Programs
              to use and access the Services. (c) The Programs as provided to
              you in accordance with the License may be used on a server or
              network which permits access by multiple users. (d) The Programs
              use an auto-installer to load the Programs onto Your central
              processing unit or server. (e) Consistent with SES's policy on
              licensing Programs that use an auto-installer, You may not
              redistribute the Programs without the prior, written consent of
              SES. Under no circumstances may You operate as a service bureau,
              application service provider, hosted or managed services provider,
              or otherwise provide the functionality of the Programs to third
              persons nor may you allow third parties to use the Programs to use
              or access the Services except as specifically provided by the
              License. (f) You agree to not (and not to authorize or allow any
              third party to) (i) decompile, disassemble, disaggregate, or
              otherwise reverse engineer or attempt to reconstruct or discover
              any source code, components (whether in object code or source code
              form), underlying ideas, processes or algorithms, or
              interoperability interfaces of the Programs by any means
              whatsoever; (ii) remove any product identification, copyright or
              other notices; (iii) modify, adapt, alter, translate or
              incorporate into or with other computer software application or
              create a derivative work of any part of the Programs; or (iv)
              disclose information or analysis (including, without limitation,
              benchmarks) regarding the quality or performance of the Programs
              except as Feedback to SES otherwise in accordance with this
              Agreement. (g) Each copy of the Programs made by You shall bear a
              conspicuous label or other marking indicating that the material is
              the property of SES and copyrighted by SES and may not be used or
              duplicated except as permitted by this Agreement.
            </li>
            <li>
              <span className="ft-wt">
                Data; License for Data Use; Business Associate.
              </span>
              (a) Data used by the Programs in the provision of the Services
              supplied by You shall be and remain Your sole and exclusive
              property and subject to the Health Insurance Portability and
              Accountability Act of 1996, as amended by the Health Information
              Technology for Economic and Clinical Health Act ("HITECH"), and
              all applicable regulations promulgated thereunder concerning the
              privacy and security of such data (collectively, "HIPAA"). You
              represent and warrant that You have all rights to use and input
              such data into the Programs and acknowledge that data conversion
              and analysis performed with the Programs, including, among other
              things, transport of such data through use of the Programs as part
              of the Services, is subject to the likelihood of human and machine
              errors, omissions, delays, and losses, including inadvertent loss
              of data or damage to media, that may give rise to loss or damage.
              SES shall not be liable for any such errors, omissions, delays, or
              losses. You are responsible for adopting reasonable measures to
              limit the impact of such problems, including backing up data, and
              adopting procedures to ensure the accuracy of input data;
              examining and confirming results prior to use; and adopting
              procedures to identify and correct errors and omissions, replace
              lost or damaged media, and reconstruct data. You shall comply with
              all local, state, and federal laws pertaining to the use and
              disclosure of any data, including, without limitation, all privacy
              regulations and requirements under HIPAA set forth at 45 C.F.R.
              Part 164. (b) You hereby grant SES a fully-paid, royalty-free
              right to access data input to the Programs by You, including,
              without limitation, the contact information, including electronic
              mail addresses and Your identity certificates (the "Data") for
              reporting, monitoring and other internal uses of SES, including,
              without limitation, as may be necessary to support the Programs
              and perform the Support Services and the marketing of the Programs
              and other services and products SES may offer or provide, provided
              however, that SES shall not store, transmit, disclose or allow
              access to any Data outside of the United States, unless You agree
              in writing for purposes such as treating patients that have
              legitimate care needs extended across national borders; such as a
              consult with a specialist in another country or to obtain records
              of care for a patient that occurred while the patient was in
              another country (the "Data Use License"). SES may use the Data
              under the Data Use License only strictly in accordance with the
              privacy and security rules under HIPAA and that any disclosure of
              Data must be de-identified such that no individually-identified
              health information ("IIHI"), or any other form of protected health
              information (including IIHI, "PHI") is disclosed to any person or
              party other than You, patient or other individual otherwise
              permitted access to such PHI under HIPAA. You agree and
              acknowledge that installation and use of the Programs requires
              that You provide SES with access to Your information technology
              infrastructure to enable SES to access Data for use in accordance
              with the Data Use License. (c) If You are a Covered Entity (as
              defined by HIPAA) or a Business Associate (as defined by HIPAA) of
              a Covered Entity, then SES is and at all times shall be and remain
              a Business Associate (as defined by HIPAA) of You. The
              functionality provided by the Programs permits You to perform
              certain translation and transformation of health care data among
              and between various data formats and standards (the "Data
              Services"), however, under no circumstances under this Agreement
              is SES performing any Data Services for You or on Your behalf, nor
              shall SES be a clearinghouse, service bureau or other such similar
              entity or organization otherwise defined under HIPAA as a Covered
              Entity. The Data Use License shall survive any termination or
              expiration of the License or this Agreement.{" "}
            </li>
            <li>
              <span className="ft-wt">
                Disclaimer of Warranty and Limited Warranty; Indemnity.
              </span>{" "}
              (a) The Programs are licensed and provided on an "AS-IS" basis.
              SES expressly disclaims any and all warranties, express or
              implied, regarding or concerning the Programs or the results or
              output produced by the Programs. You, not SES, are responsible for
              ensuring the correctness of Data entered during use of the
              Programs. You, not SES, are responsible for ensuring the
              correctness of Data entered during use of the Programs and You
              acknowledge that You are responsible for compliance with all
              applicable statutory and regulatory requirements of HIPAA
              concerning the privacy, security, transmission and format of data.
              You warrant that no use of the Programs shall make them consumer
              goods for purposes of federal or state warranty laws, and agree
              that they are not consumer goods for such purposes. (b) EXCEPT AS
              OTHERWISE PROVIDED IN THIS SECTION 5, SES MAKES NO WARRANTY OF ANY
              KIND, EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION,
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR ANY PARTICULAR
              PURPOSE. NO REPRESENTATION OR OTHER AFFIRMATION OF FACT BY ANYONE
              SHALL BE DEEMED TO BE OR CREATE A WARRANTY FROM SES OR BY ANYONE
              ELSE WHO HAS BEEN INVOLVED IN THE CREATION, PRODUCTION, OR
              DELIVERY OF THE PROGRAMS OR ANY SERVICES PROVIDED BY SES OR
              PROVIDED OTHERWISE THROUGH THIS SITE. YOU COVENANT TO SAFEGUARD
              DATA, TO USE CAUTION AND TO NOT RELY IN ANY WAY ON THE FUNCTIONING
              OR PERFORMANCE OF THE PROGRAMS OR SERVICES PROVIDED BY SES OR
              OTHERWISE THROUGH THIS SITE. (c) If and only if You are a Covered
              Entity or are a Business Associate of a Covered Entity, SES
              represents and warrants that it shall comply with the terms and
              conditions of the Business Associate Agreement located here{" "}
              <a
                href="http://www.secureexsolutions.com/baa"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                http://www.secureexsolutions.com/baa{" "}
              </a>{" "}
              with respect to the security, handling, protection, use and
              privacy of PHI (the "BAA").
            </li>
            <li>
              <span className="ft-wt">Support Services.</span> (a) So long as
              You timely pay all applicable Subscription Fees, Support Services,
              as described in paragraphs (i) and (ii) of this Section 6, will be
              provided in accordance with the Technical Support Services Policy
              set forth here{" "}
              <a
                href="http://www.secureexsolutions.com/tssp.html"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                http://www.secureexsolutions.com/tssp.html{" "}
              </a>{" "}
              (i) Software upgrades to the Programs, including Upgrades, will be
              provided to You as part of the Support Services, as they become
              generally available for release; and (ii) technical support
              services, (as set forth here{" "}
              <a
                href="http://www.secureexsolutions.com/tssp.html"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                http://www.secureexsolutions.com/tssp.html{" "}
              </a>
              ). (b) You agree to provide SES broadband access to the computers,
              network environment, information technology infrastructure,
              including, among other things, the server or all servers upon
              which the Programs are installed by You for the purpose of
              allowing SES access adequate to permit SES to monitor the usage of
              the Programs from time-to-time and at any time and to provide the
              Support Services.{" "}
            </li>
            <li>
              <span className="ft-wt">Ownership of the Programs.</span> (a) You
              acknowledge and agree that the Programs and Services are the
              property of SES, that the entire right, title, and interest
              (including any interest arising out of copyright laws) in the
              Programs and all materials relating to the Programs and the
              Services belong to SES and are made available to You for use only
              in accordance with the License and that the Programs, Services,
              and information You may receive from SES in the course of use of
              the Programs and Services and when being provided the Support
              Services contain trade secrets and Confidential Information of SES
              protected under applicable law. (b) All changes, modifications or
              improvements made or developed with regard to the Programs or
              Services by SES, whether or not made or developed at Your request,
              shall remain the property of SES and, upon disclosure or
              availability to or use by You, shall be deemed to have been part
              of the Programs and Services as of the date upon which you first
              made use of the Programs. (c) You acknowledge and agree that (i)
              the Programs may include applications, products, materials,
              systems, data, techniques, processes, information, methodologies
              and the other information and services that are proprietary to
              third-party suppliers and vendors of SES (the "Third Party IP");
              (ii) SES holds valid licenses for all Third Party IP sufficient to
              permit SES to grant you the rights provided in by the License and
              to permit You to use the Programs in accordance with the License;
              and (iii) You shall neither have nor obtain any rights in any
              Third Party IP under this Agreement except coincident to the
              License. (d) SES retains title and ownership to any and all copies
              of the Programs whether transmitted electronically or recorded on
              magnetic or optical media and all subsequent copies of the
              Programs, regardless of the form or media in or on which the
              original and other copies may exist.
            </li>
            <li>
              <span className="ft-wt">Transfer of License.</span> (a) You do not
              have the right to sell, assign or otherwise transfer copies of the
              Programs or any license in the Programs, except in connection with
              the merger, corporate reorganization or the sale of all or
              substantially all of its assets or to a parent or wholly owned
              subsidiary or successor to Your business. Any permitted successor
              shall notify SES of its succession to Your rights and shall agree
              in writing to be bound by this Agreement. (b) You represent and
              warrant that You have all authorizations and permissions to
              procure the use of the Programs for Your entity or organization
              and all applicable and indicated physicians or health care
              providers enrolled or registered to use the Programs.
            </li>
            <li>
              <span className="ft-wt">Damages; Injunctive Relief.</span> You
              agree that, if any unauthorized copies of the Programs are made,
              or if the Programs are used in violation of this Agreement, SES
              shall have the right to seek an injunction against that
              unauthorized copying or use, in addition to any other rights to
              which SES may be entitled. You agree that, if any unauthorized
              copies of the Programs are made, or if the Programs are used in
              violation of this Agreement, SES shall have the right to seek an
              injunction against that unauthorized copying or use, in addition
              to any other rights to which SES may be entitled.{" "}
            </li>
            <li>
              <span className="ft-wt">
                Limitation of Liability; Indemnification.
              </span>{" "}
              NOTWITHSTANDING ANY OTHER PROVISION OF THIS AGREEMENT, SES'S
              ENTIRE AGGREGATE LIABILITY TO YOU, REGARDLESS OF THE FORM OF ANY
              CLAIM OR ACTION OR THEORY OF LIABILITY (INCLUDING CONTRACT, TORT,
              OR WARRANTY), SHALL BE LIMITED TO THE AMOUNT OF SUBSCRIPTION FEES
              PAID. UNDER NO CIRCUMSTANCES SHALL SES HAVE ANY LIABILITY TO YOU
              FOR ANY CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, INDIRECT OR SPECIAL
              DAMAGES OR COSTS, INCLUDING, BUT NOT LIMITED TO, LOST PROFITS OR
              LOSS OF GOODWILL, RESULTING FROM ANY VIOLATION OF THIS AGREEMENT
              EVEN IF SES HAS BEEN ADVISED, KNEW OR SHOULD HAVE KNOWN OF THE
              POSSIBILITY THEREOF.
              <p>
                You agree to indemnify and hold harmless SES and its
                shareholders, directors, officers and employees, (each, an
                Indemnified Person"), from and against any losses, claims,
                damages, or liabilities, including reasonable legal expenses,
                arising out of any legal, administrative, or regulatory action,
                whether complete, pending or threatened, related to or arising
                out of this Agreement, the Programs and will pay or reimburse
                Indemnified Persons for all costs, fees, and expenses
                (including, without limitation, reasonable legal fees) incurred
                by such Indemnified Person in connection with investigating,
                preparing or defending any such action or claim (collectively a
                "Loss" or "Losses"). The foregoing indemnity agreement shall be
                in addition to any rights that any Indemnified Person may have
                at common law or otherwise, including, without limitation, any
                right to contribution.
              </p>
            </li>

            {/* <li><span className="eula-header">Special Indemnification Provisions for THSA Users.</span> APPLICABLE ONLY IF SUBJECT TO THE THSA AGREEMENT If the License is provided to You in accordance with the THSA Agreement, (a) each party shall indemnify and hold the other party harmless from and defend each other from and against any and all Losses asserted against, imposed upon or incurred by the other party resulting from or arising out of the party's act or omission, including its agents and subcontractors under this Agreement, including but not limited to negligence or intentional acts or omissions. (b)  SES agrees to indemnify and hold You and authorized users harmless from and defend it from and against any and all Losses, which arise from any claim by any third party of an alleged infringement of patent, copyright or any other property right arising out of the use of the Programs, Services or materials related to the Programs or Services provided to You (the "Licensed IP") by the You or any of Your authorized users in accordance with the terms of this Agreement, provided, however, that SES's obligations under this indemnification are expressly conditioned on the following: (i)  You shall give Vendor notice of any Losses for which You will seek indemnification within ten business (10) days of determining that it shall seek such indemnification. Lack of such notice will only relieve SES of its obligations hereunder to the extent it suffers actual prejudice as a result thereof. (ii)  You must in writing grant SES sole control of the defense of any such claim and of all negotiations for its settlement or compromise, provided that no such settlement or compromise shall impose any monetary or other obligations on You.  If You choose to represent Your own interest in any such action, You may do so at Your own expense, but such representation must not prejudice SES's right to control the defense of the claim and negotiate its settlement or compromise); (iii)  You must reasonably cooperate with SES to facilitate the settlement or defense of the claim; and (iv)  SES and its licensors shall have no liability for, and SES's indemnification obligations under this Section 11 shall not apply to, any claim of infringement based on (A) alteration or modification of any of Licensed IP in any manner by You or persons in Your employ or control, including without limitation Your authorized users, without SES's prior written authorization; (B) use of other than the then-current release of the Programs or Services if use of the then-current release would not result in the claim; (C) use of the Licensed Intellectual property not in accordance with the Specifications\; or (D) use of the Licensed IP which use breaches this Agreement or the License (collectively, the "Indemnity Exclusions").  (c) If the Licensed IP becomes, or in SES's opinion is likely to become, the subject of such a claim, SES may procure for You the right to continue using such affected Licensed IP, or to replace or modify the affected Licensed IP so as to make it non-infringing. If neither of the foregoing alternatives is reasonably available to SES, then SES may terminate the License upon written notice to You. (d) The foregoing states the entire liability of SES with respect to indemnification for patent, trademark, copyright and trade secret infringement.</li>*/}
            <li>
              <span className="ft-wt">Miscellaneous.</span> (a) This Agreement
              represents the entire agreement between the parties as to its
              subject matter and shall be governed by and construed in
              accordance with the laws of the State of Maryland without regard
              to the conflicts of laws provisions thereof; provided, however
              that certain Programs subscribed to by You may have additional or
              supplemental terms and conditions to their use. (b) Neither the
              Uniform Computer Information Transactions Act ("UCITA") (if and to
              the extent enacted in any state), nor the United Nations
              Convention on Contracts for the International Sale of Goods shall
              apply to this Agreement. To the extent UCITA is applicable
              notwithstanding the foregoing, SES and You agree to opt out of the
              applicability of UCITA pursuant to the "opt out" provisions
              contained therein. (c) You agree that the Programs will not be
              shipped, transferred, or exported or reexported into any country
              or used in any manner prohibited by the United States Export
              Administration Act or any other export laws, restrictions, or
              regulations. Specifically, and without limitation, You agree that
              the Programs will not be downloaded, accessed or otherwise
              exported or reexported to (or to a national or resident of) Cuba,
              Iraq, Libya, Sudan, North Korea, Iran, Syria or any other country
              or person to which the United States has embargoed goods. By
              agreeing to this Agreement, You are certifying that You are not a
              national of one of these countries, or otherwise a person with
              whom the U.S. government has prohibited trade. (d) The Programs
              and any related documentation are "Commercial Items," as that term
              is defined at 48 C.F.R. &sect;2.101, consisting of "Commercial
              Computer Software" and "Commercial Computer Software
              Documentation," as such terms are defined in DFARS 277-7014(a)(1),
              as applicable, and as such terms are used in 48 C.F.R.
              &sect;12.212 or 48 C.F.R. &sect;227.7202 and DFARS 227-7202-1
              through 252.227-7202-4, as applicable; and (ii) provided strictly
              in accordance with the terms and conditions of this the License
              hereunder in accordance with DFARS 227-7202-1 through 227-7202-4
              and 48 C.F.R. &sect;227.7202-1 through &sect;227.7202-4 or
              subparagraphs (b)(1) and (2) of the Commercial Computer Software
              License at 48 C.F.R. &sect;52.227-19, as applicable. (e)
              Consistent with 48 C.F.R. &sect;12.212 or 48 C.F.R.
              &sect;227.7202-1 through 227.7202-4, as applicable, the Commercial
              Computer Software and Commercial Computer Software Documentation
              are being licensed to U.S. Government end users (i) only as
              Commercial Items and (ii) with only those rights as are granted to
              all other end users pursuant to the terms and conditions set forth
              in this Agreement. Unpublished-rights reserved under the copyright
              laws of the United States. The manufacturer of the Programs is
              Secure Exchange Solutions, Inc.., 1700 Research Blvd., Ste. 220,
              Rockville, Maryland 20850. (f) To the extent applicable, SES
              agrees to comply with all applicable equal opportunity laws
              including, if appropriate, the provisions of Executive Order
              11246, as amended, Section 402 of the Vietnam Era Veterans
              Readjustment Assistance Act of 1974 (38 U.S.C. &sect;4212), and
              Section 503 of the Rehabilitation Act of 1973, as amended, and the
              regulations at 41 C.F.R. Parts 60-1 through 60-60, 60-250, and
              60-741. The affirmative action clause and regulations contained in
              the preceding sentence shall be incorporated by reference. (g)
              Except as otherwise provided in this Agreement, this Agreement may
              be modified only in a writing signed by both parties; provided,
              however, that changes made by SES to the materials, policies,
              terms and conditions applicable to this Agreement or use of the
              Programs available to You through this web site shall be
              incorporated by reference into this Agreement upon publication to
              this web site without any action of either You or SES, including,
              but not limited to, any notice. (h) Any and all notices required
              of SES may be made to You by electronic mail or other convenient
              means and notices generally applicable to all third parties
              similarly situated with You may be posted to this web site. (i)
              Each such notice shall be effective when transmitted by SES
              regardless of when or if such notice is received by You. (j) If
              any provision of this Agreement is alleged to be invalid or
              unenforceable, that provision shall be construed to have the
              broadest interpretation that would make it valid and enforceable.
              Invalidity or unenforceability of one provision shall not affect
              any other provision of this Agreement. (k) Failure or delay by
              either party in exercising any right or power under this Agreement
              shall not operate as a waiver of that right or power.{" "}
            </li>
          </ol>
          <EulaAction />
        </div>
      </section>
      <div className="ses_footer">
        <div className="ses-footer animate slide delay-2">
          <footer>
            <div className="ses-footer-container">
              <div
                className="ses-directTrust"
                title="Direct Trust Certification DTAAP HISP DTAAP CA DTAAP RA"
              ></div>
              {/*<div className="ses-drummond" title="Drummond Certification"></div>*/}
            </div>
            <div className="right-container">
              <div className="poweredby-aws">
                <a
                  href="http://hitrustalliance.net"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={HiTrustLogo}
                    className="hitrust-img"
                    alt="HITRUST logo"
                    title="HITRUST Logo"
                  />
                </a>
                {/*<a href="http://hitrustalliance.net" target="_blank"><img src={ HiTrustLogo } className="hitrust-img" alt="HITRUST logo" title="HITRUST Logo" /></a>*/}
                <img
                  src={PoweredByAWS}
                  alt="aws powered by logo"
                  title="Powered by AWS"
                />
              </div>
              <div className="contact-footer">
                <b>Technical Support:</b> 1.888.470.9913 |
                <a href="mailto:support@secureexsolutions.com">
                  {" "}
                  support@secureexsolutions.com{" "}
                </a>
              </div>
              <div className="copyright">
                For more information about our ONC certification please visit
                <a
                  href="http://www.secureexsolutions.com/ONC"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  secureexsolutions.com/ONC{" "}
                </a>
                <br />
                Copyright &copy; {currentYear} |
                <a
                  href="http://secureexsolutions.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  Secure Exchange Solutions{" "}
                </a>
                | Powered by SES Direct |
                <a
                  href="http://www.secureexsolutions.com/privacy-policy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy and Terms of Use
                </a>
              </div>
            </div>
          </footer>
        </div>
      </div>
      {processing ? <div className="loading"></div> : null}
    </div>
  );
};

export default EulaDefault;
